(() => {
  const SEL = 'div[class*="kl-private-reset-css"]';

  const isFullscreen = (el) => {
    const r = el.getBoundingClientRect();
    return r.width >= window.innerWidth * 0.9 && r.height >= window.innerHeight * 0.9;
  };

  const isClosed = (cs) => {
    if (cs.animationName === 'klaviyo-fadein') return false;
    return parseFloat(cs.opacity) === 0 ||
      cs.visibility === 'hidden' ||
      cs.display === 'none' ||
      cs.animationName === 'klaviyo-fadeout';
  };

  const setTree = (el, value) => {
    if (value) {
      el.style.setProperty('pointer-events', 'none', 'important');
    } else {
      el.style.removeProperty('pointer-events');
    }
    const kids = el.querySelectorAll('*');
    for (let i = 0; i < kids.length; i++) {
      if (value) {
        kids[i].style.setProperty('pointer-events', 'none', 'important');
      } else {
        kids[i].style.removeProperty('pointer-events');
      }
    }
  };

  const apply = () => {
    let anyOpen = false;
    document.querySelectorAll(SEL).forEach((el) => {
      const cs = getComputedStyle(el);
      if (cs.position !== 'fixed' || !isFullscreen(el)) return;
      if (isClosed(cs)) {
        setTree(el, true);
      } else {
        anyOpen = true;
        setTree(el, false);
      }
    });
    if (!anyOpen) {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        schedule();
        return;
      }
      const t = m.target;
      if (t && t.nodeType === 1 && ((t.className + '').indexOf('kl-private-reset') > -1 || (t.closest && t.closest(SEL)))) {
        schedule();
        return;
      }
    }
  });

  const start = () => {
    observer.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
    window.addEventListener('klaviyoForms', schedule);
    apply();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
